import { TrendingUp, Building2, ShieldCheck, Landmark, ArrowRight } from "lucide-react";
import { Button } from "@/components/ui/button";
import { CALENDLY_URL } from "@/lib/constants";

const services = [
  {
    icon: TrendingUp,
    title: "Vermögensaufbau mit ETFs",
    desc: "Wir entwickeln Deine individuelle ETF- und Investmentstrategie – renditeorientiert, breit gestreut und kostenoptimiert. So lässt Du Dein Kapital langfristig für Dich arbeiten.",
  },
  {
    icon: ShieldCheck,
    title: "Absicherung",
    desc: "Berufsunfähigkeit, Haftpflicht, Risikoleben: Wir vergleichen über 200 Anbieter und sichern Dich und Deine Familie zum besten Preis-Leistungs-Verhältnis ab.",
  },
  {
    icon: Landmark,
    title: "Altersvorsorge und Steuern",
    desc: "Rürup, Altersvorsorgedepot und fondsgebundene Altersvorsorge clever kombiniert: Du sicherst Dir staatliche Förderungen, sparst Steuern und schließt Deine Rentenlücke.",
  },
  {
    icon: Building2,
    title: "Immobilien als Kapitalanlage",
    desc: "Ob Direktinvestment oder Immobilienfonds – wir zeigen Dir, wie Du mit Sachwerten Vermögen aufbaust, Mieteinnahmen erzielst und Steuervorteile nutzt.",
  },
];

export default function Services() {
  return (
    <section id="services" className="py-20 md:py-28 bg-secondary/40">
      <div className="container">
        <div className="max-w-3xl mx-auto text-center reveal">
          <span className="text-accent font-semibold uppercase tracking-wider text-sm">Unsere Leistungen</span>
          <h2 className="mt-3 font-display text-3xl md:text-4xl lg:text-5xl font-bold text-primary text-balance">
            Finanzberatung & Vorsorgekonzepte nach Maß
          </h2>
          <p className="mt-4 text-lg text-muted-foreground">
            Von Altersvorsorge über Vermögensaufbau bis Versicherungen: Wir bieten Dir unabhängige Lösungen, die exakt zu Deiner Lebenssituation passen.
          </p>
        </div>

        <div className="mt-12 grid sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {services.map(({ icon: Icon, title, desc }, i) => (
            <div
              key={i}
              className="reveal group relative rounded-2xl bg-card border border-border p-6 shadow-card hover:shadow-elegant hover:-translate-y-1 transition-all duration-300 overflow-hidden"
            >
              <div className="absolute -top-12 -right-12 w-32 h-32 rounded-full bg-accent/5 group-hover:bg-accent/15 transition-colors" />
              <div className="relative w-12 h-12 rounded-xl bg-gradient-accent text-accent-foreground flex items-center justify-center shadow-glow">
                <Icon className="w-6 h-6" />
              </div>
              <h3 className="relative mt-5 font-display text-xl font-bold text-primary">{title}</h3>
              <p className="relative mt-2 text-muted-foreground leading-relaxed">{desc}</p>
            </div>
          ))}
        </div>

        <div className="mt-12 flex justify-center reveal">
          <Button asChild variant="accent" size="xl">
            <a href={CALENDLY_URL} target="_blank" rel="noopener noreferrer">
              Jetzt Erstgespräch vereinbaren <ArrowRight className="w-4 h-4" />
            </a>
          </Button>
        </div>
      </div>
    </section>
  );
}
